export default "__VITE_ASSET__CO$a6nlX__"